import { atom } from 'jotai';

import {
  RepairTypeId,
  ServiceTypeCode,
} from '@service-initiation/shared-clients-tech-care-services';
import { getRepairPrice } from '@service-initiation/tech-care-data-access-tech-care-services';

import { deviceDetailsAsyncAtom } from './deviceDetailsAsyncAtom';
import { fullAddressAtom } from './fullAddressAtom';
import { geolocationAtom } from './geolocationAtom';
import { postalCodeAtom } from './postalCodeAtom';
import { selectedRepairsAsyncAtom } from './selectedRepairsAsyncAtom';
import { selectedStoreAsyncAtom } from './selectedStoreAsyncAtom';

export const repairPriceAsyncAtom = atom(async (get) => {
  const selectedRepairs = await get(selectedRepairsAsyncAtom);

  const crackedScreenPeril = selectedRepairs.find(
    (repair) => repair.repairType.id === RepairTypeId.CrackedScreen
  );

  if (crackedScreenPeril?.id) {
    const geolocation = get(geolocationAtom);
    const fullAddress = get(fullAddressAtom);
    const postalCode = get(postalCodeAtom);
    const deviceDetails = await get(deviceDetailsAsyncAtom);
    const selectedStore = await get(selectedStoreAsyncAtom);

    if (
      (postalCode || fullAddress?.address || geolocation) &&
      deviceDetails?.id &&
      selectedStore?.id
    ) {
      return getRepairPrice({
        address: postalCode || fullAddress?.address,
        deviceRepairId: crackedScreenPeril.id,
        deviceTypeId: deviceDetails?.id,
        geoLocation: geolocation,
        serviceTypeCode: ServiceTypeCode.CARRY_IN,
        storeId: selectedStore?.id,
      });
    }
  }
});
